import { useEffect } from "react";
import { useParams } from "react-router";

import { buildRoute } from "sj-ui-toolkit/src/constants/routes";
import { useSmartNavigation } from "sj-ui-toolkit/src/helpers/navigation";

const ScormLoginRedirect = () => {
  const { navigateTo } = useSmartNavigation();
  const { idpId, lessonKey } = useParams();

  useEffect(() => {
    navigateTo(buildRoute("Login.routes.scorm.route", { idpId, lessonKey }));
  }, [navigateTo, idpId, lessonKey]);

  return null;
};

export default ScormLoginRedirect;
